import jwt_decode from "jwt-decode";
import { REFRESH_TOKEN } from "../../mutation/refreshToken";
import { nestClient } from "../../apolloClient";
import { useMutation } from "@apollo/react-hooks";
import React from "react";

export default function JWTCOMMON() {
  const [refreshTokenM] = useMutation(REFRESH_TOKEN, {
    client: nestClient,
  });

  const token = localStorage.getItem("jwt_token");
  if (token) {
    const jwt = jwt_decode(token);
    const current_time = Date.now() / 1000;
    if (jwt.exp < current_time + 100) {
      refreshTokenM({
        variables: {
          refreshToken: localStorage.getItem("refresh_token"),
        },
      })
        .then((response) => {
          const { accessToken, refreshToken } =
            response?.data?.userRefreshToken;
          localStorage.setItem("jwt_token", accessToken);
          localStorage.setItem("refresh_token", refreshToken);

          window.location.reload();
        })
        .catch((e) => {});
    }
  }
  return <></>;
}
